module.exports = __webpack_public_path__ + "static/bebas-f1fe731eb12f799714d9b9e101115597.woff";